import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, unref as _unref, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/procedure//icon_arrow-left_white.svg'
import _imports_1 from '../assets/images/joyworks_logo.png'
import _imports_2 from '../assets/images/procedure/write.png'
import _imports_3 from '../assets/images/procedure/icon_arrow-right.png'
import _imports_4 from '../assets/images/procedure/send.png'
import _imports_5 from '../assets/images/procedure/regist.png'
import _imports_6 from '../assets/images/procedure/going.png'
import _imports_7 from '../assets/images/procedure/post.png'
import _imports_8 from '../assets/images/procedure/check.png'
import _imports_9 from '../assets/images/procedure/check_out.svg'
import _imports_10 from '../assets/images/procedure/search.png'
import _imports_11 from '../assets/images/procedure/cancel.png'
import _imports_12 from '../assets/images/procedure/plus.png'


const _withScopeId = n => (_pushScopeId("data-v-d3fbbc7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%","width":"100%"} }
const _hoisted_2 = { class: "img" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity_wrapper" }, null, -1))
const _hoisted_4 = { class: "form_container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "뒤로", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_text" }, [
  /*#__PURE__*/_createElementVNode("div", null, "조이웍스"),
  /*#__PURE__*/_createElementVNode("div", null, "A/S온라인 신청서")
], -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"section2\" data-v-d3fbbc7a><div class=\"section2_text\" data-v-d3fbbc7a>조이웍스 스토어 공식 판매처에서 구매한 제품은 당사의 AS 정책에 따른 서비스를 제공받을 수 있습니다.</div><div class=\"section2_text\" data-v-d3fbbc7a>아래 신청서를 작성하시고 AS 받을 제품을 아래 주소로 보내주시기 바랍니다.</div></div><div class=\"section3\" data-v-d3fbbc7a><div class=\"section_line\" data-v-d3fbbc7a><div class=\"section_line_text\" data-v-d3fbbc7a>AS 진행 절차 안내</div><div class=\"section_line_line\" data-v-d3fbbc7a></div></div><div class=\"section3_icon_wrap\" data-v-d3fbbc7a><div class=\"section3_radious\" data-v-d3fbbc7a><div class=\"radious_number\" data-v-d3fbbc7a>01</div><div class=\"section3_radious_wrap\" data-v-d3fbbc7a><img src=\"" + _imports_2 + "\" alt=\"\" data-v-d3fbbc7a></div><div class=\"section3_radious_text\" data-v-d3fbbc7a>신청서 작성 및 제출</div></div><div data-v-d3fbbc7a><img src=\"" + _imports_3 + "\" alt=\"\" data-v-d3fbbc7a></div><div class=\"section3_radious\" data-v-d3fbbc7a><div class=\"radious_number\" data-v-d3fbbc7a>02</div><div class=\"section3_radious_wrap\" data-v-d3fbbc7a><img src=\"" + _imports_4 + "\" alt=\"\" data-v-d3fbbc7a></div><div class=\"section3_radious_text\" data-v-d3fbbc7a>제품 발송</div></div><div data-v-d3fbbc7a><img src=\"" + _imports_3 + "\" alt=\"\" data-v-d3fbbc7a></div><div class=\"section3_radious\" data-v-d3fbbc7a><div class=\"radious_number\" data-v-d3fbbc7a>03</div><div class=\"section3_radious_wrap\" data-v-d3fbbc7a><img src=\"" + _imports_5 + "\" alt=\"\" data-v-d3fbbc7a></div><div class=\"section3_radious_text\" data-v-d3fbbc7a>A/S 접수</div></div><div data-v-d3fbbc7a><img src=\"" + _imports_3 + "\" alt=\"\" data-v-d3fbbc7a></div><div class=\"section3_radious\" data-v-d3fbbc7a><div class=\"radious_number\" data-v-d3fbbc7a>04</div><div class=\"section3_radious_wrap\" data-v-d3fbbc7a><img src=\"" + _imports_6 + "\" alt=\"\" data-v-d3fbbc7a></div><div class=\"section3_radious_text\" data-v-d3fbbc7a>A/S 진행</div></div><div data-v-d3fbbc7a><img src=\"" + _imports_3 + "\" alt=\"\" data-v-d3fbbc7a></div><div class=\"section3_radious\" data-v-d3fbbc7a><div class=\"radious_number\" data-v-d3fbbc7a>05</div><div class=\"section3_radious_wrap\" data-v-d3fbbc7a><img src=\"" + _imports_7 + "\" alt=\"\" data-v-d3fbbc7a></div><div class=\"section3_radious_text\" data-v-d3fbbc7a>수신 제품 발송</div></div></div></div><div class=\"section4\" style=\"padding-bottom:10px;\" data-v-d3fbbc7a><div class=\"section_line\" data-v-d3fbbc7a><div class=\"section_line_text\" style=\"min-width:88px;\" data-v-d3fbbc7a>제품 보내실 곳</div><div class=\"section_line_line\" data-v-d3fbbc7a></div></div><div data-v-d3fbbc7a><div class=\"section4_text_line\" data-v-d3fbbc7a><div class=\"section4_imt\" data-v-d3fbbc7a>●</div><div class=\"section4_text\" data-v-d3fbbc7a>경기도 포천시 송선로 268-64(선단동) 조이웍스 <br data-v-d3fbbc7a> 물류센터 A/S 담당자 앞</div></div><div class=\"section4_text_line\" data-v-d3fbbc7a><div class=\"section4_imt\" data-v-d3fbbc7a>●</div><div class=\"section4_text\" data-v-d3fbbc7a><span class=\"text_hilight\" data-v-d3fbbc7a>대표번호 : </span><a style=\"color:#006da1;\" href=\"tel:031-524-9858\" data-v-d3fbbc7a>031-524-9858</a></div></div></div></div>", 3)
const _hoisted_12 = {
  class: "section4",
  style: {"padding-top":"10px"}
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"section_line\" data-v-d3fbbc7a><div class=\"section_line_text\" data-v-d3fbbc7a>주의사항</div><div class=\"section_line_line\" data-v-d3fbbc7a></div></div><div data-v-d3fbbc7a><div class=\"section4_text_title\" data-v-d3fbbc7a>다음 사항에 대해서는 AS가 불가능 합니다.</div><div class=\"section4_text_line\" data-v-d3fbbc7a><div class=\"section4_imt\" data-v-d3fbbc7a>●</div><div class=\"section4_text\" data-v-d3fbbc7a><span class=\"text_hilight\" data-v-d3fbbc7a>하이킹</span>(등산화)이 아닌 제품은 창갈이 <span class=\"text_hilight\" data-v-d3fbbc7a>AS 불가</span></div></div><div class=\"section4_text_line\" data-v-d3fbbc7a><div class=\"section4_imt\" data-v-d3fbbc7a>●</div><div class=\"section4_text\" data-v-d3fbbc7a><span class=\"text_hilight\" data-v-d3fbbc7a>인솔</span>(내부 깔창) 및 <span class=\"text_hilight\" data-v-d3fbbc7a>슈레이스</span>(신발 끈) <span class=\"text_hilight\" data-v-d3fbbc7a>AS 불가</span></div></div><div class=\"section4_text_line\" data-v-d3fbbc7a><div class=\"section4_imt\" data-v-d3fbbc7a>●</div><div class=\"section4_text\" data-v-d3fbbc7a><span class=\"text_hilight\" data-v-d3fbbc7a>잘 못된 세탁</span>에 의해 <span class=\"text_hilight\" data-v-d3fbbc7a>훼손</span>된 제품</div></div><div class=\"section4_text_line\" data-v-d3fbbc7a><div class=\"section4_imt\" data-v-d3fbbc7a>●</div><div class=\"section4_text\" data-v-d3fbbc7a>조이웍스 유통망이 아닌 <span class=\"text_hilight\" data-v-d3fbbc7a>병행수입</span> 된 제품</div></div><div class=\"section4_text_line\" data-v-d3fbbc7a><div class=\"section4_imt\" data-v-d3fbbc7a>●</div><div class=\"section4_text\" data-v-d3fbbc7a>택배 발송 시 <span class=\"text_hilight\" data-v-d3fbbc7a>인적사항 동봉</span></div></div></div>", 2)
const _hoisted_15 = {
  key: 0,
  class: "check_img",
  src: _imports_8,
  alt: ""
}
const _hoisted_16 = {
  key: 1,
  class: "check_img",
  src: _imports_9,
  alt: ""
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_text" }, "확인 했습니다.", -1))
const _hoisted_18 = { class: "section5" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"section_line\" data-v-d3fbbc7a><div class=\"section_line_text\" data-v-d3fbbc7a>AS 신청</div><div class=\"section_line_line\" data-v-d3fbbc7a></div></div><div class=\"section5_wrap\" data-v-d3fbbc7a><div class=\"section5_text\" data-v-d3fbbc7a><span class=\"section5_imt\" data-v-d3fbbc7a>*</span>는 필수항목 입니다.</div></div>", 2)
const _hoisted_21 = { class: "input_wrap" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, [
  /*#__PURE__*/_createTextVNode("성명"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "*")
], -1))
const _hoisted_23 = ["readonly"]
const _hoisted_24 = { class: "input_wrap" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, [
  /*#__PURE__*/_createTextVNode("전화번호"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "*")
], -1))
const _hoisted_26 = { class: "input_number_wrap" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_desc" }, "반드시 000-0000-0000 형태로 입력해 주세요.", -1))
const _hoisted_28 = { class: "input_wrap" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, [
  /*#__PURE__*/_createTextVNode("주소"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "*")
], -1))
const _hoisted_30 = { class: "input_text_wrap" }
const _hoisted_31 = ["readonly"]
const _hoisted_32 = ["readonly"]
const _hoisted_33 = { class: "input_wrap" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, [
  /*#__PURE__*/_createTextVNode("제품명"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "*")
], -1))
const _hoisted_35 = { class: "input_text_wrap" }
const _hoisted_36 = ["readonly"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_desc" }, "의뢰하신 제품 명을 기입해 주세요. (ex 본디8, 카하2 GTX등)", -1))
const _hoisted_38 = { class: "input_wrap" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, [
  /*#__PURE__*/_createTextVNode("색상"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "*")
], -1))
const _hoisted_40 = { class: "input_text_wrap" }
const _hoisted_41 = ["readonly"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_desc" }, [
  /*#__PURE__*/_createTextVNode("색상(예) HOKA신발의 경우 :BBLC, DOTN 등 숫자 7 자리 옆에 표시"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("모를 경우 색상만 기입")
], -1))
const _hoisted_43 = { class: "input_wrap" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, [
  /*#__PURE__*/_createTextVNode("사이즈"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "*")
], -1))
const _hoisted_45 = { class: "input_text_wrap" }
const _hoisted_46 = ["readonly"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_desc" }, "(예) 270:신발 / XL: 의류 및 침낭류", -1))
const _hoisted_48 = { class: "input_wrap" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, [
  /*#__PURE__*/_createTextVNode("구매년월"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "*")
], -1))
const _hoisted_50 = { class: "input_text_wrap" }
const _hoisted_51 = { class: "input_wrap" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, [
  /*#__PURE__*/_createTextVNode("수선 요청사항"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "*")
], -1))
const _hoisted_53 = { class: "input_text_wrap" }
const _hoisted_54 = ["readonly"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_desc" }, "수선이 필요한 사항에 대해서 구체적으로 적어주시기 바랍니다.", -1))
const _hoisted_56 = { class: "radio_wrap" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, "구매처", -1))
const _hoisted_58 = { class: "radio_box" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "online",
  class: "radio_desc"
}, "네이버 조이웍스 스토어", -1))
const _hoisted_61 = { class: "radio_box" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "offline",
  class: "radio_desc"
}, "공식 취급점", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_label label_desc" }, "구매하신 곳의 정확한 상호명과 영수증을 함께 제출해 주세요.", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_label label_desc" }, "※ 구매처가 드롭다운 목록에 없을 경우, 공식 취급점이 아니므로 접수 불가 및 반송될 수 있습니다.", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_label label_desc" }, "※ 무신사, 크림(KREAM) 등 외부 플랫폼을 통한 구매건의 경우 해당 플랫폼의 정책에 따라 구매처를 통해 접수 및 처리가 진행됩니다. 반드시 해당 구매처 고객센터를 통해 문의 부탁드립니다.", -1))
const _hoisted_67 = {
  key: 0,
  class: "input_wrap"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_label" }, [
  /*#__PURE__*/_createTextVNode("공식 취급점"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "*")
], -1))
const _hoisted_69 = { class: "input_text_wrap" }
const _hoisted_70 = { class: "button_wrap" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_label" }, "구매증빙 예시(1장)", -1))
const _hoisted_72 = { class: "radio_box" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "receipt",
  class: "radio_desc"
}, "일반 영수증", -1))
const _hoisted_75 = { class: "radio_box" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "vircle",
  class: "radio_desc"
}, "버클(정품인증서)", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_label label_desc" }, "※구매증빙 미 첨부시 유상 접수 혹은 접수불가 판정을 받을 수 있습니다.", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_label label_desc" }, "[단, 버클(정품인증서)을 발급받으신 고객님께서는 인증서 캡쳐 본을 첨부하시면 됩니다.]", -1))
const _hoisted_80 = {
  key: 0,
  style: {"display":"flex","gap":"6px"}
}
const _hoisted_81 = ["onClick"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_text" }, "이미지 첨부", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_plus",
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_84 = [
  _hoisted_82,
  _hoisted_83
]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_desc" }, "구매한 영수증이나 인터넷 몰 구매내역 캡쳐 본", -1))
const _hoisted_86 = { class: "button_wrap" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_label" }, "제품 택 이미지 예시(최대 2장)", -1))
const _hoisted_88 = {
  key: 0,
  style: {"display":"flex","gap":"6px","flex-wrap":"wrap"}
}
const _hoisted_89 = ["onClick"]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_plus",
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_text" }, "이미지 첨부", -1))
const _hoisted_93 = {
  key: 0,
  class: "icon_plus",
  src: _imports_12,
  alt: ""
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_desc" }, "선명하게 촬영해 주세요", -1))
const _hoisted_95 = { class: "button_wrap" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_label" }, "수선이 필요한 부분 사진 예시(최대 3장)", -1))
const _hoisted_97 = {
  key: 0,
  style: {"display":"flex","gap":"6px"}
}
const _hoisted_98 = ["onClick"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_plus",
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_text" }, "이미지 첨부", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_plus",
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_103 = [
  _hoisted_101,
  _hoisted_102
]
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_desc" }, "필수 항목입니다.", -1))
const _hoisted_105 = { class: "button_wrap" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_label" }, [
  /*#__PURE__*/_createTextVNode("약관 동의"),
  /*#__PURE__*/_createElementVNode("span", { class: "section5_imt" }, "(필수)")
], -1))
const _hoisted_107 = {
  key: 0,
  class: "check_img",
  src: _imports_8,
  alt: ""
}
const _hoisted_108 = {
  key: 1,
  class: "check_img",
  src: _imports_9,
  alt: ""
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_text" }, "약관 전체 동의", -1))
const _hoisted_110 = { class: "agreement_wrap" }
const _hoisted_111 = { class: "agreement_box" }
const _hoisted_112 = { class: "agreement_box" }
const _hoisted_113 = { class: "button_regist_wrap" }
const _hoisted_114 = {
  key: 0,
  class: "terms"
}
const _hoisted_115 = {
  key: 1,
  class: "terms"
}

import { onMounted, ref } from "vue";
import repairAPI from "@/api/repairAPI";
import codeAPI from "@/api/codeAPI";
import router from "@/router";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Terms1View from "@/views/Terms1View.vue";
import Terms2View from "./Terms2View.vue";
import authAPI from "@/api/authAPI";

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientRegist',
  setup(__props) {

const store = useStore();
const route = useRoute();
const userInfo = ref();
const readOnlyFlag = ref(false);
const storeType: any = ref(0);
const param: any = ref({
  STR_CODE: "",
  CUS_NAME: "",
  CUS_HP_NO: "",
  ITM_NAME: "",
  REMARK01: "",
  ZIP_CODE: "",
  CUS_ADDR: "",
  CUS_ADDR2: "",
  SIZE_NAME: "",
  COLOR_NAME: "",
  BUY_YM: "",
  RECEIPT_GUBUN: "",
});
const phone: any = ref({
  phone1: "",
  phone2: "",
  phone3: "",
});
const file1 = ref();
const file2 = ref();
const file3 = ref();
const fileList: any = ref({ file1: [], file2: [], file3: [] });
// const url = ref("http://localhost:8081/joyworks_as_api");
const url = ref("https://service.joy-works.co.kr/");



const checkFlag: any = ref(false);
const checkAgree: any = ref(false);
const checkAgree1: any = ref(false);
const checkAgree2: any = ref(false);
const strList: any = ref([]);
const termsFlag1: any = ref(false);
const termsFlag2: any = ref(false);
const checkSession = () => {
  authAPI
    .checkSession()
    .then((res: any) => {
      console.log(res);
      const data = res.data.data;
      if (data.result == "FAIL") {
        router.push({ name: "clientLogin" });
      }
    })
    .catch((error: any) => {
      console.log(error);
      alert(error);
    });
};
// const base64PreFix = (data: any) => {
//   return "data:image/png;base64," + data;
// };

onMounted(() => {
  checkSession();
  getStr();
  userInfo.value = store.getters.getUserInfo;
  phone.value.phone1 = userInfo.value.EMP_NO.substr(0, 3);
  phone.value.phone2 = userInfo.value.EMP_NO.substr(3, 4);
  phone.value.phone3 = userInfo.value.EMP_NO.substr(7, 4);
  if (route.params.SEQ_NO) {
    checkFlag.value = true;
    checkAgree.value = true;
    checkAgree1.value = true;
    checkAgree2.value = true;
    repairAPI.GetRepairDetail({ SEQ_NO: route.params.SEQ_NO, CUS_HP_NO: userInfo.value.EMP_NO }).then((res) => {
      param.value = res.data.data;
      // param.value.BUY_YM = convertDateYm(param.value.BUY_YM);
      phone.value.phone1 = param.value.CUS_HP_NO.substr(0, 3);
      phone.value.phone2 = param.value.CUS_HP_NO.substr(3, 4);
      phone.value.phone3 = param.value.CUS_HP_NO.substr(7, 4);
      if (route.params.SEQ_NO && param.value.CS_STATUS != null) {
        readOnlyFlag.value = true;
      }
      res.data.data.IMG_LIST.map((data: any) => {
        if (data.IMG_GUBUN == "01") {
          fileList.value.file1.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ, src: url.value + data.IMG_PATH });
        } else if (data.IMG_GUBUN == "02") {
          fileList.value.file2.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ, src: url.value + data.IMG_PATH });
        } else {
          fileList.value.file3.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ, src: url.value + data.IMG_PATH });
        }
      });
    });
  }
});

const AddImg = (el: any) => {
  if (readOnlyFlag.value == true) {
    return;
  }
  if (el == file1.value) {
    if (fileList.value.file1.length < 2) {
      file1.value.click();
    } else {
      alert("등록 가능한 이미지는 최대 2장입니다.");
    }
  } else if (el == file2.value) {
    if (fileList.value.file2.length < 4) {
      file2.value.click();
    } else {
      alert("등록 가능한 이미지는 최대 3장입니다.");
    }
  } else {
    file3.value.click();
  }
};
let removeImgList: any = [];
const DelFile1Img = (el: any) => {
  if (readOnlyFlag.value == true) {
    return;
  }
  fileList.value.file1.map((data: any, idx: any) => {
    if (data == el) {
      fileList.value.file1.splice(idx, 1);
      if (data.IMG_SEQ) {
        removeImgList.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ });
      }
    }
  });
};
const DelFile2Img = (el: any) => {
  if (readOnlyFlag.value == true) {
    return;
  }
  fileList.value.file2.map((data: any, idx: any) => {
    if (data == el) {
      fileList.value.file2.splice(idx, 1);
      if (data.IMG_SEQ) {
        removeImgList.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ });
      }
    }
  });
};
const DelFile3Img = (el: any) => {
  if (readOnlyFlag.value == true) {
    return;
  }
  fileList.value.file3.map((data: any, idx: any) => {
    if (data == el) {
      fileList.value.file3.splice(idx, 1);
      if (data.IMG_SEQ) {
        removeImgList.push({ SEQ_NO: data.SEQ_NO, IMG_SEQ: data.IMG_SEQ });
      }
    }
  });
};

const updateImg1 = (el: any) => {
  var fileArr = Array.prototype.slice.call(el.files);
  fileArr.map((file: any) => {
    if (file.type == "image/png" || file.type == "image/jpg" || file.type == "image/jpeg") {
      var reader = new FileReader();
      reader.onload = function (readerEvent: any) {
        file.src = reader.result;
        if (el.files.length + fileList.value.file1.length > 2) {
          alert("등록 가능한 이미지는 최대 2장입니다.");
          file1.value.value = "";
        } else {
          const image = new Image();
          image.onload = function () {
            let canvas: any = document.createElement("canvas");
            let max_size = 1280;
            // 최대 기준을 1280으로 잡음.
            let width = image.width;
            let height = image.height;
            if (width > height) {
              if (width > max_size) {
                height *= max_size / width;
                width = max_size;
              }
            } else {
              // 세로가 길 경우
              if (height > max_size) {
                width *= max_size / height;
                height = max_size;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            file = dataUrlToFile(canvas.toDataURL("image/jpeg"), file.name);
            file.src = canvas.toDataURL("image/jpeg");
            fileList.value.file1.push(file);
            file1.value.value = "";
          };
          image.src = readerEvent.target.result;
          // fileList.value.file1.push(file);
          // file1.value.value = "";
        }
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
      reader.readAsDataURL(file);
    } else {
      alert("이미지 파일이 아닙니다.");
      return;
    }
  });
};

const updateImg2 = (el: any) => {
  var fileArr = Array.prototype.slice.call(el.files);
  fileArr.map((file: any) => {
    if (file.type == "image/png" || file.type == "image/jpg" || file.type == "image/jpeg") {
      var reader = new FileReader();
      reader.onload = function (readerEvent: any) {
        file.src = reader.result;
        if (el.files.length + fileList.value.file2.length > 3) {
          alert("등록 가능한 이미지는 최대 3장입니다.");
          file2.value.value = "";
        } else {
          const image = new Image();
          image.onload = function () {
            let canvas: any = document.createElement("canvas");
            let max_size = 1280;
            // 최대 기준을 1280으로 잡음.
            let width = image.width;
            let height = image.height;
            if (width > height) {
              if (width > max_size) {
                height *= max_size / width;
                width = max_size;
              }
            } else {
              // 세로가 길 경우
              if (height > max_size) {
                width *= max_size / height;
                height = max_size;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            file = dataUrlToFile(canvas.toDataURL("image/jpeg"), file.name);

            file.src = canvas.toDataURL("image/jpeg");
            fileList.value.file2.push(file);
            file2.value.value = "";
          };
          image.src = readerEvent.target.result;
        }
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
      reader.readAsDataURL(file);
    } else {
      alert("이미지 파일이 아닙니다.");
      return;
    }
  });
};
const updateImg3 = (el: any) => {
  var fileArr = Array.prototype.slice.call(el.files);
  fileArr.map((file: any) => {
    if (file.type == "image/png" || file.type == "image/jpg" || file.type == "image/jpeg") {
      var reader = new FileReader();
      reader.onload = function (readerEvent: any) {
        const image = new Image();
        image.onload = function () {
          let canvas: any = document.createElement("canvas");
          let max_size = 1280;
          // 최대 기준을 1280으로 잡음.
          let width = image.width;
          let height = image.height;
          if (width > height) {
            if (width > max_size) {
              height *= max_size / width;
              width = max_size;
            }
          } else {
            // 세로가 길 경우
            if (height > max_size) {
              width *= max_size / height;
              height = max_size;
            }
          }
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(image, 0, 0, width, height);
          file = dataUrlToFile(canvas.toDataURL("image/jpeg"), file.name);

          file.src = canvas.toDataURL("image/jpeg");
          fileList.value.file3.push(file);
          file3.value.value = "";
        };
        image.src = readerEvent.target.result;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
      reader.readAsDataURL(file);
    } else {
      alert("이미지 파일이 아닙니다.");
      return;
    }
  });
};
const dataUrlToFile = (dataUrl: any, filename: any) => {
  var blobBin = atob(dataUrl.split(",")[1]); // base64 데이터 디코딩
  var array = [];
  for (var i = 0; i < blobBin.length; i++) {
    array.push(blobBin.charCodeAt(i));
  }
  return new File([new Uint8Array(array)], filename.split(".")[0] + ".jpeg", { type: "image/jpeg" }); // Blob 생성
};
const save = () => {
  if (checkFlag.value != true) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "주의사항을 확인하세요.",
    });
    return;
  }
  if (param.value.CUS_NAME == "" || param.value.CUS_NAME.length > 8) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "성명을 확인하세요.",
    });
    return;
  }
  if (param.value.CUS_ADDR == "") {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "주소를 확인하세요.",
    });
    return;
  }
  if (param.value.CUS_ADDR2 == "") {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "상세주소를 확인하세요.",
    });
    return;
  }
  if (param.value.ITM_NAME == "" || param.value.ITM_NAME.length > 30) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "제품명을 확인하세요.",
    });
    return;
  }
  if (param.value.COLOR_NAME == "" || param.value.COLOR_NAME.length > 10) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "색상을 확인하세요.",
    });
    return;
  }
  if (param.value.SIZE_NAME == "" || param.value.SIZE_NAME.length > 5) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "사이즈을 확인하세요.",
    });
    return;
  }
  if (param.value.BUY_YM == "") {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "구매년월을 확인하세요.",
    });
    return;
  }
  // if (param.value.REMARK01 == "") {
  //   window.customAlert({
  //     title: "A/S 고객접수",
  //     msg: "수선요청사항을 확인하세요.",
  //   });
  //   return;
  // }
  if (storeType.value == "1" && param.value.STR_CODE == "") {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "구매처를 확인하세요.",
    });
    return;
  }
  if (checkAgree.value != true) {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "약관에 동의해주세요.",
    });
    return;
  }
  // storeType에 상관없이 본사로 지정
  param.value.STR_CODE = "0000";
  param.value.storeType;
  let formData = new FormData();
  param.value.CUS_HP_NO = phone.value.phone1 + "" + phone.value.phone2 + "" + phone.value.phone3;
  param.value.removeImgList = JSON.stringify(removeImgList);
  formData.append(
    "param",
    new Blob([JSON.stringify(param.value)], {
      type: "application/json",
    })
  );
  for (let i = 0; i < fileList.value.file1.length; i++) {
    if (!fileList.value.file1[i].IMG_SEQ) {
      formData.append("file1", fileList.value.file1[i]);
    }
  }
  for (let i = 0; i < fileList.value.file2.length; i++) {
    if (!fileList.value.file2[i].IMG_SEQ) {
      formData.append("file2", fileList.value.file2[i]);
    }
  }
  for (let i = 0; i < fileList.value.file3.length; i++) {
    if (!fileList.value.file3[i].IMG_SEQ) {
      formData.append("file3", fileList.value.file3[i]);
    }
  }
  window.customConfirm({
    title: "A/S 고객접수",
    msg: "접수하시겠습니까?",
    sCb: function () {
      repairAPI.SetCustomerRepair(formData).then((res: any) => {
        if (res.data.status == 200) {
          param.value.SEQ_NO = res.data.data.result;
          window.customAlert({
            title: "A/S 고객접수",
            msg: "AS 접수가 완료되었습니다",
            sCb: function () {
              router.push({ name: "clientDetail", params: { SEQ_NO: param.value.SEQ_NO } });
              removeImgList = [];
            },
          });
        }
      });
    },
  });
};
const searchAddr = () => {
  if (readOnlyFlag.value == true) {
    return;
  }

  new window.daum.Postcode({
    oncomplete: (data: any) => {
      param.value.CUS_ADDR = data.jibunAddress != "" ? data.jibunAddress : data.autoJibunAddress;
      param.value.ZIP_CODE = data.zonecode;
      // param.value.ZIP_CODE = data.jibunAddress != "" ? data.jibunAddress : data.autoJibunAddress;
    },
  }).open({
    popupName: "addressPop",
  });
};
const getStr = () => {
  codeAPI.getStr().then((res: any) => {
    const resData = res.data.data;
    resData.map((data: any) => {
      strList.value.push({ id: data.STR_CODE, text: data.STR_NAME });
    });
  });
};
const checkAgreement = () => {
  if (readOnlyFlag.value == true) {
    return;
  }
  checkAgree.value = !checkAgree.value;
  if (checkAgree.value) {
    checkAgree1.value = true;
    checkAgree2.value = true;
  } else {
    checkAgree1.value = false;
    checkAgree2.value = false;
  }
};
const checkAgreement1 = () => {
  if (readOnlyFlag.value == true) {
    return;
  }
  checkAgree1.value = !checkAgree1.value;
  if (checkAgree1.value && checkAgree2.value) {
    checkAgree.value = true;
  } else {
    checkAgree.value = false;
  }
};
const checkAgreement2 = () => {
  if (readOnlyFlag.value == true) {
    return;
  }
  checkAgree2.value = !checkAgree2.value;
  if (checkAgree1.value && checkAgree2.value) {
    checkAgree.value = true;
  } else {
    checkAgree.value = false;
  }
};
const checkIn = () => {
  if (readOnlyFlag.value == true) {
    return;
  }
  checkFlag.value = !checkFlag.value;
};
const goHome = () => {
  router.push({ name: "clientHome" });
};
const goBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Select2 = _resolveComponent("Select2")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", { class: "section1" }, [
          _createElementVNode("div", { class: "section_header_wrap" }, [
            _createElementVNode("div", {
              onClick: goBack,
              class: "back_btn_box"
            }, _hoisted_7),
            _createElementVNode("img", {
              src: _imports_1,
              style: {"cursor":"pointer"},
              onClick: goHome,
              alt: ""
            })
          ]),
          _hoisted_8
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", {
            class: _normalizeClass(["section4_button_wrap", { check_in: !checkFlag.value }]),
            onClick: checkIn
          }, [
            (checkFlag.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_15))
              : _createCommentVNode("", true),
            (!checkFlag.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_16))
              : _createCommentVNode("", true),
            _hoisted_17
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                class: "input_text",
                placeholder: "성명",
                readonly: readOnlyFlag.value,
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((param.value.CUS_NAME) = $event))
              }, null, 8, _hoisted_23), [
                [_vModelText, param.value.CUS_NAME]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                class: "input_number",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phone.value.phone1) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, phone.value.phone1]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "input_number",
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phone.value.phone2) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, phone.value.phone2]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "input_number",
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((phone.value.phone3) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, phone.value.phone3]
              ])
            ]),
            _hoisted_27
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                class: "input_text",
                placeholder: "주소",
                onClick: searchAddr,
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((param.value.CUS_ADDR) = $event)),
                readonly: readOnlyFlag.value
              }, null, 8, _hoisted_31), [
                [_vModelText, param.value.CUS_ADDR]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "input_text",
                placeholder: "상세주소",
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((param.value.CUS_ADDR2) = $event)),
                readonly: readOnlyFlag.value
              }, null, 8, _hoisted_32), [
                [_vModelText, param.value.CUS_ADDR2]
              ])
            ]),
            _createElementVNode("img", {
              class: "icon_search",
              onClick: searchAddr,
              src: _imports_10,
              alt: ""
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _withDirectives(_createElementVNode("input", {
                class: "input_text",
                placeholder: "제품명",
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((param.value.ITM_NAME) = $event)),
                readonly: readOnlyFlag.value
              }, null, 8, _hoisted_36), [
                [_vModelText, param.value.ITM_NAME]
              ])
            ]),
            _hoisted_37
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                class: "input_text",
                placeholder: "색상",
                type: "text",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((param.value.COLOR_NAME) = $event)),
                readonly: readOnlyFlag.value
              }, null, 8, _hoisted_41), [
                [_vModelText, param.value.COLOR_NAME]
              ])
            ]),
            _hoisted_42
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _withDirectives(_createElementVNode("input", {
                class: "input_text",
                placeholder: "사이즈",
                type: "text",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((param.value.SIZE_NAME) = $event)),
                readonly: readOnlyFlag.value
              }, null, 8, _hoisted_46), [
                [_vModelText, param.value.SIZE_NAME]
              ])
            ]),
            _hoisted_47
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_el_date_picker, {
                modelValue: param.value.BUY_YM,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((param.value.BUY_YM) = $event)),
                style: {"width":"100%","height":"39px"},
                type: "month",
                locale: "ko",
                placeholder: "YYYY. MM",
                "value-format": "YYYYMM",
                format: "YYYY. MM",
                readonly: readOnlyFlag.value
              }, null, 8, ["modelValue", "readonly"])
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, [
              _withDirectives(_createElementVNode("textarea", {
                class: "textArea_text",
                type: "text",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((param.value.REMARK01) = $event)),
                readonly: readOnlyFlag.value
              }, null, 8, _hoisted_54), [
                [_vModelText, param.value.REMARK01]
              ])
            ]),
            _hoisted_55
          ]),
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("div", _hoisted_58, [
              _withDirectives(_createElementVNode("input", {
                id: "online",
                name: "buyshop",
                checked: "",
                class: "radio_radio",
                value: "0",
                type: "radio",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((storeType).value = $event)),
                disabled: readOnlyFlag.value
              }, null, 8, _hoisted_59), [
                [_vModelRadio, storeType.value]
              ]),
              _hoisted_60
            ]),
            _createElementVNode("div", _hoisted_61, [
              _withDirectives(_createElementVNode("input", {
                id: "offline",
                name: "buyshop",
                value: "1",
                class: "radio_radio",
                type: "radio",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((storeType).value = $event)),
                disabled: readOnlyFlag.value
              }, null, 8, _hoisted_62), [
                [_vModelRadio, storeType.value]
              ]),
              _hoisted_63
            ]),
            _hoisted_64,
            _hoisted_65,
            _hoisted_66
          ]),
          (storeType.value == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _hoisted_68,
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_Select2, {
                    modelValue: param.value.STR_CODE,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((param.value.STR_CODE) = $event)),
                    options: strList.value,
                    settings: { width: '100%', height: '34px' }
                  }, null, 8, ["modelValue", "options"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", null, [
              _createVNode(_component_el_image, {
                class: "img_sample",
                src: require(`@/assets/images/receipt.png`),
                "zoom-rate": 1.2,
                "max-scale": 7,
                "min-scale": 0.2,
                "preview-src-list": [require(`@/assets/images/receipt.png`)],
                fit: "cover"
              }, null, 8, ["src", "preview-src-list"])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _withDirectives(_createElementVNode("input", {
                id: "receipt",
                name: "buy_gubun",
                checked: "",
                class: "radio_radio",
                value: "1",
                type: "radio",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((param.value.RECEIPT_GUBUN) = $event)),
                disabled: readOnlyFlag.value
              }, null, 8, _hoisted_73), [
                [_vModelRadio, param.value.RECEIPT_GUBUN]
              ]),
              _hoisted_74
            ]),
            _createElementVNode("div", _hoisted_75, [
              _withDirectives(_createElementVNode("input", {
                id: "vircle",
                name: "buy_gubun",
                value: "2",
                class: "radio_radio",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((param.value.RECEIPT_GUBUN) = $event)),
                type: "radio",
                disabled: readOnlyFlag.value
              }, null, 8, _hoisted_76), [
                [_vModelRadio, param.value.RECEIPT_GUBUN]
              ]),
              _hoisted_77
            ]),
            _hoisted_78,
            _hoisted_79,
            (fileList.value.file3.length != 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value.file3, (cnt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "img_box",
                      key: cnt
                    }, [
                      _createVNode(_component_el_image, {
                        style: {"height":"100%"},
                        src: cnt.src,
                        "zoom-rate": 1.2,
                        "max-scale": 7,
                        "min-scale": 0.2,
                        "preview-src-list": [cnt.src],
                        fit: "cover"
                      }, null, 8, ["src", "preview-src-list"]),
                      _createElementVNode("img", {
                        class: "icon_cancel",
                        src: _imports_11,
                        alt: "",
                        onClick: ($event: any) => (DelFile3Img(cnt))
                      }, null, 8, _hoisted_81)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "button_text_wrap",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (AddImg(file3.value)))
                }, _hoisted_84)),
            _createElementVNode("input", {
              type: "file",
              name: "",
              ref_key: "file3",
              ref: file3,
              accept: ".jpg, .png, .jpeg",
              onChange: _cache[17] || (_cache[17] = ($event: any) => (updateImg3(file3.value))),
              style: {"display":"none"}
            }, null, 544),
            _hoisted_85
          ]),
          _createElementVNode("div", _hoisted_86, [
            _hoisted_87,
            _createElementVNode("div", null, [
              _createVNode(_component_el_image, {
                class: "img_sample",
                src: require(`@/assets/images/tag.jpg`),
                "zoom-rate": 1.2,
                "max-scale": 7,
                "min-scale": 0.2,
                "preview-src-list": [require(`@/assets/images/tag.jpg`)],
                fit: "cover"
              }, null, 8, ["src", "preview-src-list"])
            ]),
            (fileList.value.file1.length != 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value.file1, (cnt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "img_box",
                      key: cnt
                    }, [
                      _createVNode(_component_el_image, {
                        style: {"height":"100%"},
                        src: cnt.src,
                        "zoom-rate": 1.2,
                        "max-scale": 7,
                        "min-scale": 0.2,
                        "preview-src-list": [cnt.src],
                        fit: "cover"
                      }, null, 8, ["src", "preview-src-list"]),
                      _createElementVNode("img", {
                        class: "icon_cancel",
                        src: _imports_11,
                        alt: "",
                        onClick: ($event: any) => (DelFile1Img(cnt))
                      }, null, 8, _hoisted_89)
                    ]))
                  }), 128)),
                  (fileList.value.file1.length < 2 && readOnlyFlag.value == false)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "img_box",
                        style: {"cursor":"pointer"},
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (AddImg(file1.value)))
                      }, _hoisted_91))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "button_text_wrap",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (AddImg(file1.value)))
                }, [
                  _hoisted_92,
                  (readOnlyFlag.value == false)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_93))
                    : _createCommentVNode("", true)
                ])),
            _createElementVNode("input", {
              type: "file",
              name: "",
              ref_key: "file1",
              ref: file1,
              accept: ".jpg, .png, .jpeg",
              onChange: _cache[20] || (_cache[20] = ($event: any) => (updateImg1(file1.value))),
              style: {"display":"none"},
              multiple: ""
            }, null, 544),
            _hoisted_94
          ]),
          _createElementVNode("div", _hoisted_95, [
            _hoisted_96,
            _createElementVNode("div", null, [
              _createVNode(_component_el_image, {
                class: "img_sample",
                src: require(`@/assets/images/repair_needs.jpg`),
                "zoom-rate": 1.2,
                "max-scale": 7,
                "min-scale": 0.2,
                "preview-src-list": [require(`@/assets/images/repair_needs.jpg`)],
                fit: "cover"
              }, null, 8, ["src", "preview-src-list"])
            ]),
            (fileList.value.file2.length != 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value.file2, (cnt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "img_box",
                      key: cnt
                    }, [
                      _createVNode(_component_el_image, {
                        style: {"height":"100%"},
                        src: cnt.src,
                        "zoom-rate": 1.2,
                        "max-scale": 7,
                        "min-scale": 0.2,
                        "preview-src-list": [cnt.src],
                        fit: "cover"
                      }, null, 8, ["src", "preview-src-list"]),
                      _createElementVNode("img", {
                        class: "icon_cancel",
                        src: _imports_11,
                        alt: "",
                        onClick: ($event: any) => (DelFile2Img(cnt))
                      }, null, 8, _hoisted_98)
                    ]))
                  }), 128)),
                  (fileList.value.file2.length < 3 && readOnlyFlag.value == false)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "img_box",
                        style: {"cursor":"pointer"},
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (AddImg(file2.value)))
                      }, _hoisted_100))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "button_text_wrap",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (AddImg(file2.value)))
                }, _hoisted_103)),
            _createElementVNode("input", {
              type: "file",
              name: "",
              ref_key: "file2",
              ref: file2,
              accept: ".jpg, .png, .jpeg",
              onChange: _cache[23] || (_cache[23] = ($event: any) => (updateImg2(file2.value))),
              style: {"display":"none"},
              multiple: ""
            }, null, 544),
            _hoisted_104
          ]),
          _createElementVNode("div", _hoisted_105, [
            _hoisted_106,
            _createElementVNode("div", {
              class: _normalizeClass(["agree_button_wrap", { check_in: !checkAgree.value }]),
              onClick: checkAgreement
            }, [
              (checkAgree.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_107))
                : _createCommentVNode("", true),
              (!checkAgree.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_108))
                : _createCommentVNode("", true),
              _hoisted_109
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("div", _hoisted_111, [
              (checkAgree1.value == true)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "check_img",
                    src: _imports_8,
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (checkAgreement1())),
                    alt: ""
                  }))
                : _createCommentVNode("", true),
              (checkAgree1.value == false)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "check_img",
                    src: _imports_9,
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (checkAgreement1())),
                    alt: ""
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "agreement_text",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (checkAgreement1()))
              }, "개인정보 제공 동의"),
              _createElementVNode("img", {
                class: "arrow_img",
                src: _imports_3,
                alt: "",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (termsFlag1.value = true))
              })
            ]),
            _createElementVNode("div", _hoisted_112, [
              (checkAgree2.value == true)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "check_img",
                    src: _imports_8,
                    alt: "",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (checkAgreement2()))
                  }))
                : _createCommentVNode("", true),
              (checkAgree2.value == false)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "check_img",
                    src: _imports_9,
                    alt: "",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (checkAgreement2()))
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "agreement_text",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (checkAgreement2()))
              }, "개인정보 처리 위탁 동의"),
              _createElementVNode("img", {
                class: "arrow_img",
                src: _imports_3,
                alt: "",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (termsFlag2.value = true))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_113, [
            (!readOnlyFlag.value && _unref(route).params.SEQ_NO != null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button_regist",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (save()))
                }, "수정하기"))
              : _createCommentVNode("", true),
            (!_unref(route).params.SEQ_NO)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "button_regist",
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (save()))
                }, "접수하기"))
              : _createCommentVNode("", true)
          ])
        ]),
        (termsFlag1.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
              _createVNode(Terms1View),
              _createElementVNode("div", {
                class: "terms_btn button_regist termsChk",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (termsFlag1.value = false))
              }, "확인")
            ]))
          : _createCommentVNode("", true),
        (termsFlag2.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
              _createVNode(Terms2View),
              _createElementVNode("div", {
                class: "terms_btn button_regist termsChk",
                onClick: _cache[35] || (_cache[35] = ($event: any) => (termsFlag2.value = false))
              }, "확인")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})